import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class AiSearchToken {
  token = ""
  expiresAt: Date | null = null
}

export const AI_SEARCH_TOKEN_DESER: SchemaDeSer<AiSearchToken> =
  new SchemaDeSerBuilder(AiSearchToken)
    .ofString("token")
    .ofDateTime("expiresAt")
    .toDeSer()
